import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import ArrowLeft from './arrow-left.svg'
import styles from './styles.css'

interface BackButtonProps extends RouteComponentProps<{}> {
  label: string
}

const BackButton: React.SFC<BackButtonProps> = ({ label, history }) => {
  return (
    <button className={styles.back} onClick={() => history.goBack()}>
      <ArrowLeft /> {label}
    </button>
  )
}

export default withRouter(BackButton)
